export const profiles = [
  {
    name: 'Amber Williams',
    title: ' Lead UX/UI Designer',
    imageSrc: '/images/profiles/amber-williams.jpg',
    body: (
      <p>
        I love creating harmony between people and technology.
        <br />
        See her work at{' '}
        <a href="https://amberwilliams.art" target="_blank" rel="noreferrer">
          amberwilliams.art
        </a>
      </p>
    ),
  },
  {
    name: 'Khari Johnson',
    title: ' Software Developer',
    imageSrc: '/images/profiles/khari-johnson.jpg',
    body: (
      <p>
        Khari is a modern web app developer who helps startups and entrepreneus
        that align with his mission to “make the world a better place, one
        interface at a time.”
        <br />
        Explore GVEMPIRE at{' '}
        <a href="https://gvempire.dev" target="_blank" rel="noreferrer">
          gvempire.dev
        </a>
      </p>
    ),
  },
  {
    name: 'Julia Mossbridge',
    title: ' PhD, Principal Investigator and Project Director',
    imageSrc: '/images/profiles/julia-mossbridge.jpg',
    body: (
      <p>
        My focus in life and research is to teach and learn about love and time
        -- I created{' '}
        <a href="https://loveandtime.org" target="_blank" rel="noreferrer">
          TILT: The Institute for Love and Time
        </a>{' '}
        to support this goal and extend this work to others.
      </p>
    ),
  },
  {
    name: 'Michael Sapiro',
    title: ' PsyD, Clinical Psychologist and Program Consultant',
    imageSrc: '/images/profiles/michael-sapiro.jpg',
    body: (
      <p>
        Dr. Sapiro teaches nationally on the art and science of transformation,
        expanded human capabilities, self-care, and meditation for personal
        awakening and community development.
        <br />
        He can be found at{' '}
        <a
          href="https://www.michaelsapiro.com"
          target="_blank"
          rel="noreferrer"
        >
          https://www.michaelsapiro.com
        </a>
      </p>
    ),
  },
  {
    name: 'Polly Washburn',
    title: ' Project Manager',
    imageSrc: '/images/profiles/polly-washburn.jpeg',
    body: (
      <p>
        Polly's career has included web and web app development; project
        management; journalism; and filmmaking.
        <br />
        See a project showcase at{' '}
        <a href="https://codyssia.com" target="_blank" rel="noreferrer">
          codyssia.com
        </a>
      </p>
    ),
  },
];
